import { ref, get } from "firebase/database";
import { db } from "../firebaseConfig";
import { InvoiceData } from "../../models/invoice";

export const getInvoiceByNumber = async (
	invoiceNumber: string
): Promise<InvoiceData | null> => {
	try {
		const invoiceRef = ref(db, "invoices");
		const snapshot = await get(invoiceRef);

		if (!snapshot.exists()) return null;

		const invoices = snapshot.val();

		for (const key in invoices) {
			if (invoices[key].invoiceNumber === invoiceNumber) {
				return invoices[key];
			}
		}

		return null; // Not found
	} catch (error) {
		console.error("Error fetching invoice by number:", error);
		throw error;
	}
};
